// extracted by mini-css-extract-plugin
export default {"SkillImage":"SkillImage_SkillImage__btL1G","image":"SkillImage_image__9-Vj0","icon":"SkillImage_icon__8cx6w","swing-in":"SkillImage_swing-in__6bpji"};